'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as SfdcIntegrationStatusActions from 'DesignData/actions/SalesforceIntegrationStatus';
import { getUserHasReadAccessOnly } from 'DesignData/selectors/auth';
import { getIsModuleStyleFieldsUngated, getIsModuleCategoriesUngated } from 'DesignData/selectors/gates';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import { getHasGlobalContentEditorAccess } from 'DesignData/selectors/auth';
import { getIsProjectsFile } from 'DesignData/selectors/finder';
import MainSidebar from 'DesignEditorsUI/components/customWidgetEditor/sidebar/main/MainSidebar';
const EMPTY_ARRAY = Object.freeze([]);

function makeMapStateToProps() {
  const getCustomWidgetBufferContentFields = customWidgetBuffersSelectors.makeGetCustomWidgetBufferContentFields();
  const getCustomWidgetBufferStyleFields = customWidgetBuffersSelectors.makeGetCustomWidgetBufferStyleFields();
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getAssets = customWidgetBuffersSelectors.makeGetAssets();
  const getIsEmailOrAnyType = customWidgetBuffersSelectors.makeGetIsEmailOrAnyType();
  const getIsReadOnly = customWidgetBuffersSelectors.makeGetIsReadOnly();
  return (state, props) => {
    const customWidgetBuffer = getCustomWidgetBuffer(state, props);
    const isEditingGlobalContent = customWidgetEditorOptionsSelectors.getIsEditingGlobalContent(state, props);
    const {
      isActive,
      fieldType
    } = customWidgetEditorOptionsSelectors.getFieldGrouping(state, props);
    return {
      assets: getAssets(state, props),
      isBufferLoaded: !!customWidgetBuffer,
      customWidgetIcon: customWidgetBuffer ? customWidgetBuffer.icon : null,
      customWidgetId: props.customWidgetId,
      moduleId: customWidgetBuffer ? customWidgetBuffer.moduleId : null,
      customWidgetLabel: customWidgetBuffer ? customWidgetBuffer.name : '',
      isGlobal: customWidgetBuffer ? customWidgetBuffer.global : false,
      customWidgetCategories: customWidgetBuffer ? customWidgetBuffer.categories : EMPTY_ARRAY,
      customWidgetTags: customWidgetBuffer ? customWidgetBuffer.contentTags : EMPTY_ARRAY,
      isV1: customWidgetBuffer ? customWidgetBuffer.schemaVersion === 1 : false,
      fields: getCustomWidgetBufferContentFields(state, props),
      styleFields: getCustomWidgetBufferStyleFields(state, props),
      isModuleCategoriesUngated: getIsModuleCategoriesUngated(state),
      isModuleStyleFieldsUngated: getIsModuleStyleFieldsUngated(state),
      fieldsErrors: customWidgetBuffersSelectors.getFieldsErrors(state, props),
      fieldsWarnings: customWidgetBuffersSelectors.getFieldsWarnings(state, props),
      hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state),
      isFieldGroupingActive: !!isActive,
      fieldType,
      isReadOnly: getUserHasReadAccessOnly(state) || getIsReadOnly(state, props) || isEditingGlobalContent || !!getIsProjectsFile(state, {
        fileId: props.customWidgetId
      }),
      moduleErrors: customWidgetBuffersSelectors.getModuleErrors(state, props),
      accordionStates: customWidgetEditorOptionsSelectors.getAccordionStates(state, props),
      customWidgetPath: customWidgetBuffer ? customWidgetBuffer.path : '',
      isEmailOrAnyType: getIsEmailOrAnyType(state, props),
      customWidgetInlineHelpText: customWidgetBuffer ? customWidgetBuffer.inlineHelpText : '',
      fieldCreateOptions: customWidgetEditorOptionsSelectors.getFieldCreateOptions(state, props)
    };
  };
}

const mapDispatchToProps = {
  createField: CustomWidgetBufferActions.createField,
  createFieldGroup: CustomWidgetBufferActions.createFieldGroup,
  toggleFieldGrouping: CustomWidgetEditorOptionsActions.toggleFieldGrouping,
  toggleFieldGroupingSelection: CustomWidgetEditorOptionsActions.toggleFieldGroupingSelection,
  updateCustomWidget: CustomWidgetBufferActions.update,
  saveAccordionState: CustomWidgetEditorOptionsActions.saveAccordionState,
  fetchSfdcIntegrationStatus: SfdcIntegrationStatusActions.fetch
};

class MainSidebarContainer extends Component {
  constructor(...args) {
    super(...args);

    this.updateCustomWidget = changes => {
      const {
        customWidgetId,
        updateCustomWidget
      } = this.props;
      updateCustomWidget(customWidgetId, changes);
    };

    this.saveAccordionState = (key, isOpen = false) => {
      this.props.saveAccordionState(this.props.customWidgetId, key, isOpen);
    };
  }

  componentDidMount() {
    this.props.fetchSfdcIntegrationStatus();
  }

  render() {
    const {
      accordionStates,
      assets,
      createField,
      createFieldGroup,
      customWidgetIcon,
      customWidgetId,
      customWidgetPath,
      customWidgetCategories,
      fieldCreateOptions,
      fields,
      styleFields,
      isModuleCategoriesUngated,
      isModuleStyleFieldsUngated,
      hasGlobalContentEditorAccess,
      isFieldGroupingActive,
      fieldType,
      isReadOnly,
      isV1,
      moduleId,
      revisionId,
      toggleFieldGrouping,
      toggleFieldGroupingSelection,
      isEmailOrAnyType,
      fieldsErrors,
      fieldsWarnings,
      moduleErrors,
      customWidgetInlineHelpText
    } = this.props;

    if (!this.props.isBufferLoaded) {
      return null;
    }

    return /*#__PURE__*/_jsx(MainSidebar, {
      accordionStates: accordionStates,
      assets: assets,
      createField: createField,
      createFieldGroup: createFieldGroup,
      customWidgetIcon: customWidgetIcon,
      customWidgetId: customWidgetId,
      customWidgetLabel: this.props.customWidgetLabel,
      customWidgetPath: customWidgetPath,
      customWidgetCategories: customWidgetCategories,
      customWidgetTags: this.props.customWidgetTags,
      fieldCreateOptions: fieldCreateOptions,
      fields: fields,
      styleFields: styleFields,
      isModuleCategoriesUngated: isModuleCategoriesUngated,
      isModuleStyleFieldsUngated: isModuleStyleFieldsUngated,
      fieldsErrors: fieldsErrors,
      fieldsWarnings: fieldsWarnings,
      hasGlobalContentEditorAccess: hasGlobalContentEditorAccess,
      isFieldGroupingActive: isFieldGroupingActive,
      fieldType: fieldType,
      isGlobal: this.props.isGlobal,
      isReadOnly: isReadOnly,
      isV1: isV1,
      moduleErrors: moduleErrors,
      moduleId: moduleId,
      revisionId: revisionId,
      toggleFieldGrouping: toggleFieldGrouping,
      toggleFieldGroupingSelection: toggleFieldGroupingSelection,
      updateCustomWidget: this.updateCustomWidget,
      saveAccordionState: this.saveAccordionState,
      isEmailOrAnyType: isEmailOrAnyType,
      customWidgetInlineHelpText: customWidgetInlineHelpText
    });
  }

}

MainSidebarContainer.propTypes = {
  assets: PropTypes.object.isRequired,
  createField: PropTypes.func.isRequired,
  createFieldGroup: PropTypes.func.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  moduleId: PropTypes.number,
  isFieldGroupingActive: PropTypes.bool.isRequired,
  fieldCreateOptions: PropTypes.object.isRequired,
  fieldType: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.instanceOf(CustomWidgetField)).isRequired,
  styleFields: PropTypes.instanceOf(CustomWidgetField),
  isModuleCategoriesUngated: PropTypes.bool,
  isModuleStyleFieldsUngated: PropTypes.bool,
  isReadOnly: PropTypes.bool.isRequired,
  toggleFieldGrouping: PropTypes.func.isRequired,
  toggleFieldGroupingSelection: PropTypes.func.isRequired,
  revisionId: PropTypes.number,
  updateCustomWidget: PropTypes.func.isRequired,
  saveAccordionState: PropTypes.func.isRequired,
  accordionStates: PropTypes.object.isRequired,
  customWidgetIcon: PropTypes.string,
  isBufferLoaded: PropTypes.bool.isRequired,
  isGlobal: PropTypes.bool.isRequired,
  customWidgetLabel: PropTypes.string.isRequired,
  customWidgetCategories: PropTypes.array.isRequired,
  customWidgetTags: PropTypes.array.isRequired,
  fetchSfdcIntegrationStatus: PropTypes.func.isRequired,
  isV1: PropTypes.bool.isRequired,
  customWidgetPath: PropTypes.string.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool,
  isEmailOrAnyType: PropTypes.bool.isRequired,
  fieldsErrors: PropTypes.object.isRequired,
  fieldsWarnings: PropTypes.object.isRequired,
  moduleErrors: PropTypes.object.isRequired,
  customWidgetInlineHelpText: PropTypes.string
};
MainSidebarContainer.defaultProps = {
  accordionStates: {}
};
export default connect(makeMapStateToProps, mapDispatchToProps)(MainSidebarContainer);